<template>

  <div class="manage">
    <el-dialog
      :title="operateType === 'add' ? '新增数据类型' : '编辑数据类型'"
      :visible.sync="isShow"
    >
      <CommonForm
        :form-label="operateFormLabel"
        :form="operateForm"
      >
      </CommonForm>

      <span slot="footer" class="dialog-footer">
        <el-button @click="isShow = false">取 消</el-button>
        <el-button @click="confirm">确 定</el-button>
      </span>

    </el-dialog>

    <div class="manage-header">
      <el-row style="height: 0.18rem">
        <el-col :span="6">
          <div style="text-align: left">
            <el-button class="function-button1" icon="el-icon-plus" @click="addInspectLabel">新增</el-button>
            <el-button class="function-button2" icon="el-icon-edit" @click="editInspectLabel">编辑</el-button>
            <el-button class="function-button3" icon="el-icon-delete" @click="deleteInspectLabel">删除</el-button>
          </div>
        </el-col>
        <el-col :span="18">
          <CommonForm inline :form-label="formLabel" :form="searchFrom">
            <el-button class="search-button" @click="getInspectLabels">搜索</el-button>
            <el-button class="reset-button" @click="resetSearch">重置</el-button>
          </CommonForm>
        </el-col>
      </el-row>
    </div>

    <el-divider class="divideLine"></el-divider>

    <CommonTableSelect
      :table-data="tableData"
      :table-label="tableLabel"
      :config="config"
      @changePage="getInspectLabels"
      @sizeChange="sizeChange"
      @currentChange="currentChange">
    </CommonTableSelect>
  </div>


</template>
<style>
</style>
<script>
import CommonTableSelect from '../components/CommonTableSelect'
import CommonForm from '../components/CommonForm'
import Util from '../commonjs/util'
export default {
  name: 'InspectLabel',
  components: {
    CommonTableSelect,
    CommonForm
  },
  data() {
    return {
      isShow: false,
      searchFrom: {
        id: '',
        industrialNetCode: '',
        productNo: '',
        productModel: ''
      },
      //   dialog form
      operateForm: {
        id: '',
        industrialNetCode: '',
        productNo: '',
        productModel: '',
        valveDn: '',
        effectForm: '',
        medium: '',
        pressureClass: '',
        temperature: '',
        flangeType: '',
        leakLevel: '',
        trip: '',
        orderNo: ''
      },
      // dialog  formlabel
      operateFormLabel: [
        {
          model: 'industrialNetCode',
          label: '网络识别编码'
        },
        {
          model: 'productNo',
          label: '产品编号'
        },
        {
          model: 'productModel',
          label: '产品型号'
        },
        {
          model: 'valveDn',
          label: '公称通径'
        },
        {
          model: 'effectForm',
          label: '作用形式'
        },
        {
          model: 'medium',
          label: '介质'
        },
        {
          model: 'pressureClass',
          label: '压力等级'
        },
        {
          model: 'temperature',
          label: '温度'
        },
        {
          model: 'flangeType',
          label: '法兰形式'
        },
        {
          model: 'leakLevel',
          label: '泄露等级'
        },
        {
          model: 'trip',
          label: '行程'
        },
        {
          model: 'orderNo',
          label: '合同编号'
        }
      ],
      formLabel: [
        {
          model: 'industrialNetCode',
          label: '网络识别编码'
        },
        {
          model: 'productNo',
          label: '产品编号'
        },
        {
          model: 'productModel',
          label: '产品型号'
        }
      ],
      config: {
        sizes: [10, 20, 30],
        count: 0,
        limit: 10,
        page: 1,
        loading: true,
        showBar: false
      },
      tableData: [],
      tableLabel: [
        {
          prop: 'industrialNetCode',
          label: '网络识别编码',
          width: '220'
        },
        {
          prop: 'productNo',
          label: '产品编号',
          width: '100'
        },
        {
          prop: 'productModel',
          label: '产品型号',
          width: '180'
        },
        {
          prop: 'valveDn',
          label: '公称通径',
          width: '90'
        },
        {
          prop: 'effectForm',
          label: '作用形式',
          width: '90'
        },
        {
          prop: 'medium',
          label: '介质',
          width: '80'
        },
        {
          prop: 'pressureClass',
          label: '压力等级',
          width: '90'
        },
        {
          prop: 'temperature',
          label: '温度',
          width: '110'
        },
        {
          prop: 'flangeType',
          label: '法兰形式',
          width: '120'
        },
        {
          prop: 'leakLevel',
          label: '泄露等级',
          width: '180'
        },
        {
          prop: 'trip',
          label: '行程',
          width: '60'
        },
        {
          prop: 'createTime',
          label: '创建时间',
          width: '190'
        },
        {
          prop: 'orderNo',
          label: '合同编号',
          width: '120'
        }
      ],
      operateType: 'add'
    }
  },
  created() {
    this.getInspectLabels()
  },

  methods: {
    open() {
      this.$confirm('确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    canOperate() {
      if (Util.isEmptyObj(this.operateForm)) return false
      else return true
    },
    addInspectLabel() {
      this.operateType = 'add'
      this.isShow = true
      Util.cleaerObj(this.operateForm)
    },
    editInspectLabel() {
      if (this.canOperate()) {
        this.operateType = 'edit'
        this.isShow = true
      } else {
        this.$message({
          message: '还未选择要操作的数据',
          type: 'warning'
        })
      }
    },
    deleteInspectLabel() {
      if (this.canOperate()) {
        this.operateType = 'del'
        this.$confirm('确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.confirm()
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      } else {
        this.$message({
          message: '还未选择要操作的数据',
          type: 'warning'
        })
      }
    },
    getInspectLabels() {
      this.config.loading = true
    },
    sizeChange(size) {
      this.config.limit = size
      this.getInspectLabels()
    },
    confirm() {
    },
    resetSearch() {
      Util.cleaerObj(this.searchFrom)
      this.getInspectLabels()
    },
    currentChange(val) {
      Util.listAssign(this.operateForm, val)
    }
  }
}

</script>

<style lang="scss" scoped>
  @import "../scss/commonTableVue";
</style>
